export default "__VITE_ASSET__CVFPnRVf__"